/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
  HttpParams
} from "@angular/common/http";
import { BaseService } from "../base-service";
import { ApiConfiguration } from "../api-configuration";
import { Observable } from "rxjs/Observable";
import { map } from "rxjs/operators/map";
import { filter } from "rxjs/operators/filter";

import { TicketType } from "../models/ticket-type";
import { TicketTypeForm } from "../models/ticket-type-form";
import { TicketAllocate } from "../models/ticket-allocate";
import { TicketAllocateSearch } from "../models/ticket-allocate-search";
import { TicketAllocateNewForm } from "../models/ticket-allocate-new-form";
import { TicketAllocateForm } from "../models/ticket-allocate-form";
import { TicketTypeInput } from "../models/ticket-type-input";
import { TicketSold } from "../models/ticket-sold";
import { TicketSoldNewForm } from "../models/ticket-sold-new-form";
import { TicketSoldSearch } from "../models/ticket-sold-search";
import { TicketReverse } from "../models/ticket-reverse";
import { TicketReverseSearch } from "../models/ticket-reverse-search";

@Injectable()
export class ManagerTicketAgentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   */

  managerTicketAgentResponse(params: any): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.from_date != null) __params = __params.set("from_date", params.from_date.toString());
    if (params.to_date != null) __params = __params.set("to_date", params.to_date.toString());

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/ticket-agent`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: any = null;
        _body = _resp.body as any
        return _resp.clone({body: _body}) as HttpResponse<any>;
      })
    );
  }
  /**
   * @param page - The number of items to skip before starting to collect the result set.
   * @param limit - The numbers of items to return.
   * @param disable - The numbers of items to return.
   */
  managerTicketAgent(params: any): Observable<any> {
    return this.managerTicketAgentResponse(params).pipe(
      map(_r => _r.body)
    );
  }

  /**
   * Download ticket zip file (returns base64)
   * @param params - { file_name: string, year_month: string }
   */
  downloadTicketZipResponse(params: any): Observable<HttpResponse<any>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.file_name != null) __params = __params.set("file_name", params.file_name.toString());
    if (params.year_month != null) __params = __params.set("year_month", params.year_month.toString());

    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/manager/ticket-agent/download`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      filter(_r => _r instanceof HttpResponse),
      map(_r => {
        let _resp = _r as HttpResponse<any>;
        let _body: any = null;
        _body = _resp.body as any
        return _resp.clone({body: _body}) as HttpResponse<any>;
      })
    );
  }

  /**
   * @param params - { file_name: string, year_month: string }
   */
  downloadTicketZip(params: any): Observable<any> {
    return this.downloadTicketZipResponse(params).pipe(
      map(_r => _r.body)
    );
  }
}
